// src/pages/Billing/BillingCancel.jsx
import React from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function BillingCancel() {
  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center mt-5">
      <Card
        className="p-4 text-center"
        style={{ maxWidth: 420, width: "100%" }}
      >
        <h4 className="mb-2">Payment canceled</h4>
        <p className="text-muted mb-4">
          No charges were made. You can review plans or return to your profile
          anytime.
        </p>

        <div className="d-flex justify-content-center gap-2 flex-wrap">
          <Button
            className="lpp-pill-btn"
            onClick={() => navigate("/subscribe")}
          >
            View plans
          </Button>

          <Button
            variant="outline-secondary"
            className="lpp-pill-btn-outline"
            onClick={() => navigate("/profile")}
          >
            Back to profile
          </Button>
        </div>
      </Card>
    </div>
  );
}
